import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import ClaroBackground from "@/assets/Img/ClaroPay/claro-red-background.svg";
import PhoneRingingIcon from "@/assets/Icons/phone-ringing.svg?react";
import ReceiptCheckIcon from "@/assets/Icons/receipt-check.svg?react";
import CoinSendIcon from "@/assets/Icons/coin-send.svg?react";
import ShoppingCartIcon from "@/assets/Icons/shopping-cart-check.svg?react";
import WithdrawalIcon from "@/assets/Icons/withdrawal-2.svg?react";
import SendIcon from "@/assets/Icons/send.svg?react";
import UserIcon from "@/assets/Icons/user.svg?react";
import RedDecoration from "@/assets/Img/ClaroPay/red-decoration.svg?react";
import WomanSmiling from "@/assets/Img/ClaroPay/woman-smiling.png";
import WomanSmilingCountries from "@/assets/Img/ClaroPay/woman-smiling-countries.png";
import ManSmiling from "@/assets/Img/ClaroPay/man-smiling.png";
import ClaroPayLogo from "@/assets/Img/ClaroPay/claropay-small.png";
import TelcelLogo from "@/assets/Img/ClaroPay/telcel-logo.png";
import ClaroMockEs from "@/assets/Img/ClaroPay/claro-mock-es.png";
import ClaroMockEn from "@/assets/Img/ClaroPay/claro-mock-en.png";
import PaymentMockEs from "@/assets/Img/angle-payment-mock-es.png";
import PaymentMockEn from "@/assets/Img/angle-payment-mock-en.png";
import SendolaPayLogo from "@/assets/Img/logo-sendola-pay.png";
import SendolaPayLogoWhite from "@/assets/Img/logo-sendola-pay-white.png";
import MXIcon from "@/assets/Img/Flags/flag-mexico.png";
import USIcon from "@/assets/Img/Flags/flag-us.png";
import ClaroPayLargeLogo from "@/assets/Img/ClaroPay/claropay-large.svg?react";
import ZelleLogo from "@/assets/Img/ClaroPay/zelle.svg?react";
import VenomLogo from "@/assets/Img/ClaroPay/venmo.svg?react";
import PayPalLogo from "@/assets/Img/ClaroPay/paypal.svg?react";
import AchLogo from "@/assets/Img/ClaroPay/ach.svg?react";
import { Button } from "@/components/Button";
import { useTranslation } from "react-i18next";
import { ClaroNumberedCard } from "@/components/ClaroNumberedCard";
import { ClaroText } from "@/components/ClaroRaysText";
import {
  CLAROPAY_INVITE_TEXT,
  CLAROPAY_INVITE_TEXT_SENDER,
  CLAROPAY_OPEN_ACCOUNT,
  CLAROPAY_PESO_X_MEGA_TERMS,
} from "@/constants/ClaroPay";
import { Card } from "@/components/Card";
import HubspotContactForm from "@/components/HubspotContactForm";
import Cookies from "universal-cookie";

const AuthUrl = import.meta.env.VITE_AUTH_DOMAIN;
const SignupUrlWithSource = `${AuthUrl}/sign-up?source=claropay`;

const cookies = new Cookies();

export default function ClaroPay() {
  const [t, i18n] = useTranslation("global");
  const lang = i18n.language;

  const shareInvite = () => {
    if (navigator?.share || navigator?.canShare()) {
      const shareOptions = {
        text: CLAROPAY_INVITE_TEXT_SENDER,
        url: CLAROPAY_OPEN_ACCOUNT,
      };

      navigator.share(shareOptions);
    }
  };

  const shareSamePage = () => {
    gtag("event", "ShareClaroPay_sendme");
    if (navigator?.share || navigator?.canShare()) {
      const shareOptions = {
        text: CLAROPAY_INVITE_TEXT,
        url: `${window.location.href}`,
      };

      navigator.share(shareOptions);
    }
  };

  useEffect(() => {
    const languageSet = Boolean(localStorage.getItem("languageSet"));

    if (window && window.location?.hash) {
      const id = window.location.hash.replace("#", "");
      const element = document.getElementById(id);

      if (element) element.scrollIntoView();
    }

    setTimeout(() => {
      if (!languageSet) {
        i18n.changeLanguage("es", () => {
          cookies.set("lang", "es");
          localStorage.setItem("languageSet", "true");
        });
      }
    }, 100);
  }, []);

  return (
    <>
      <Helmet>
        <title>Sendola | ClaroPay</title>
      </Helmet>
      <div className="w-full flex flex-col items-center justify-center relative bg-white">
        {/* Header Desktop */}
        <div className="w-full h-[30rem] bg-[#e6edfd] relative hidden md:block">
          <img
            className="w-full h-full object-fill absolute left-0 top-0 z-0 object-center"
            src={ClaroBackground}
            alt=""
          />
          <div className="w-full h-full flex items-center justify-between z-10 relative">
            <div className="w-[53%] h-full flex flex-col justify-between">
              <div className="flex justify-center items-center h-full w-full">
                <div className="flex flex-col gap-4 items-center justify-center px-6 lg:px-10">
                  <h1
                    className="w-full text-4xl xl:text-[42px] xl:leading-[3rem] text-center md:text-left text-white font-light [&_span]:font-semibold"
                    dangerouslySetInnerHTML={{
                      __html: t("ClaroPay.title"),
                    }}
                  />

                  <p className="w-full text-xl xs:text-2xl lg:text-3xl text-center md:text-left text-white font-light max-sm:mt-8">
                    {t("ClaroPay.doItWith")}
                    <img
                      className="inline h-16 w-auto object-contain select-none -translate-y-2"
                      src={SendolaPayLogoWhite}
                      alt="Sendola's Logo"
                    />
                  </p>
                </div>
              </div>
              <div className="flex justify-center items-center h-[50%] pt-4">
                <div className="h-auto w-auto flex flex-row md:flex-col xl:flex-row gap-4 items-start xl:items-center justify-center px-6 lg:px-10">
                  <p className="w-full lg:text-xl text-left font-medium max-w-xl">
                    {t("ClaroPay.receiveMoney")}
                    {"  "}
                    <ClaroPayLargeLogo className="inline h-7 mx-1 w-auto object-contain select-none -translate-y-2" />
                    {t("ClaroPay.orAnyAccount")}
                    {"  "}
                  </p>

                  <Button
                    onClick={shareSamePage}
                    className="text-base !font-medium !px-6 !w-fit !gap-2 !bg-gradient-to-r from-[#b20105] to-[#f70208] !py-3 !border-0 flex-shrink-0"
                  >
                    {t("ClaroPay.askFor")}
                  </Button>
                </div>
              </div>
            </div>
            <div className="w-[47%] h-full flex justify-center items-end lg:px-4">
              <img
                className="w-full max-w-[32rem] h-full object-contain object-bottom"
                src={WomanSmilingCountries}
                alt="Woman smiling"
              />
            </div>
          </div>
        </div>

        {/* Header Mobile */}
        <div className="relative flex flex-col items-center w-full h-[30rem] bg-gradient-to-b from-[#f60208] via-[#f20208] to-[#a30003] md:hidden overflow-hidden">
          <RedDecoration className="w-[14rem] h-[20rem] absolute bottom-0 left-0 translate-y-4" />
          <div className="flex flex-col gap-4 items-center justify-center px-6 pt-6">
            <h1
              className="text-2xl sm:text-3xl text-white text-center inner-span-semibold font-light"
              dangerouslySetInnerHTML={{
                __html: t("ClaroPay.title"),
              }}
            />

            <p className="w-full text-xl xs:text-2xl text-center md:text-left text-white font-light mt-3">
              {t("ClaroPay.doItWith")}
              <img
                className="inline h-12 xs:h-14 w-auto object-contain select-none -translate-y-2"
                src={SendolaPayLogoWhite}
                alt="Sendola's Logo"
              />
            </p>
          </div>

          <div className="w-full h-full absolute left-0 top-0 bg-gradient-to-b from-transparent to-black/60 z-50 from-70% flex flex-col items-center justify-end pb-10 gap-2">
            <Button
              link={SignupUrlWithSource}
              target="_blank"
              rel={["noopener", "noreferrer"]}
              className="!bg-primary-500 !border-0 !text-base !font-medium !px-8 !py-2 !gap-2"
            >
              {t("ClaroPay.sendMoneyNow")}
            </Button>
            <a href="#benefits" className="text-white underline font-medium">
              {t("ClaroPay.knowMore")}
            </a>
          </div>

          <img
            className="w-auto h-[20rem] object-contain object-bottom z-20 absolute px-2 bottom-0"
            src={WomanSmilingCountries}
            alt="Woman with smartphone"
          />
        </div>
        <div className="flex md:hidden justify-center items-center w-full h-auto py-6 px-10 gap-4 bg-white">
          <div className="flex flex-col gap-4 items-center justify-center p-4 shadow shadow-black/20 rounded-2xl">
            <p className="w-full text-sm text-center font-medium">
              {t("ClaroPay.receiveMoney")}
              {"  "}
              <ClaroPayLargeLogo className="inline h-5 mx-1 w-auto object-contain select-none -translate-y-1" />
              {t("ClaroPay.orAnyAccount")}
              {"  "}
            </p>

            <Button
              onClick={shareSamePage}
              className="text-sm !font-medium !px-6 !w-fit !gap-2 !bg-gradient-to-r from-[#b20105] to-[#f70208] !py-3 !border-0 flex-shrink-0"
            >
              {t("ClaroPay.askFor")}
            </Button>
          </div>
        </div>

        <div className="w-full flex items-center justify-center flex-col-reverse md:flex-row overflow-hidden bg-[#e6edfd]">
          <div className="w-full md:w-1/2 xl:w-1/3 flex flex-col items-center 2xl:items-end justify-end self-stretch flex-shrink-0">
            <div className="w-full h-auto flex flex-col items-center gap-2">
              <div className="flex flex-col max-md:px-6 justify-between md:justify-end w-full gap-12 pt-6 ">
                <div className="hidden md:flex flex-col items-center justify-center pl-6 gap-4">
                  <p className="w-fit text-2xl lg:text-3xl text-primary-800 font-semibold max-w-lg ml-10 px-4">
                    {t("ClaroPay.benefitsTitle")}
                  </p>
                  {lang === "en" ? (
                    <img
                      className="object-contain w-full h-auto max-w-[20rem] md:max-w-[24rem] flex-shrink-0 max-xs:hidden -mb-28"
                      src={ClaroMockEn}
                      alt=""
                    />
                  ) : (
                    <img
                      className="object-contain w-full h-auto max-w-[20rem] md:max-w-[24rem] flex-shrink-0 max-xs:hidden -mb-28"
                      src={ClaroMockEs}
                      alt=""
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div
            id="benefits"
            className="w-fit flex flex-col items-center justify-center gap-6 md:gap-10 max-w-screen-lg pb-8"
          >
            <p className="w-full text-center text-xl md:hidden text-primary-800 font-semibold px-6 mt-8">
              {t("ClaroPay.benefitsTitle")}
            </p>
            <div className="w-full flex justify-center items-center gap-x-4 gap-y-2 lg:gap-x-6 lg:gap-y-2 md:pt-8 flex-wrap">
              <img
                className="h-12 md:h-14 lg:h-16 w-auto object-contain"
                src={SendolaPayLogo}
                alt="SendolaPay's logo"
              />
              <img
                className="h-12 md:h-14 lg:h-16 w-auto object-contain"
                src={ClaroPayLogo}
                alt="ClaroPay's logo"
              />
              <img
                className="h-8 sm:h-10 md:h-12 lg:h-12 w-auto object-contain"
                src={TelcelLogo}
                alt="ClaroPay's logo"
              />
            </div>

            <div className="w-fit flex flex-col gap-1 px-6 max-w-screen-sm">
              <ClaroText
                text={t("ClaroPay.lines.line1")}
                textClassName="[&_span]:font-semibold"
                extra={
                  <div className="hidden sm:flex items-center w-fit pl-2">
                    <img
                      className="w-7 h-7 md:w-8 md:h-8 flex-shrink-0"
                      src={USIcon}
                      alt="US"
                    />
                    <img
                      className="w-7 h-7 md:w-8 md:h-8 -ml-[10%] flex-shrink-0"
                      src={MXIcon}
                      alt="MX"
                    />
                  </div>
                }
              />
              <ClaroText
                text={t("ClaroPay.lines.line2")}
                textClassName="[&_span]:font-semibold inner-span-italic"
              />
              <ClaroText
                text={t("ClaroPay.lines.line3")}
                textClassName="[&_span]:font-semibold"
              />

              <p className="w-full text-center font-medium text-xs text-[#8795c3] mt-8">
                *{t("ClaroPay.lines.disclaimer")}{" "}
                <a
                  className="text-primary-500 font-medium hover:text-primary-400"
                  href={CLAROPAY_PESO_X_MEGA_TERMS}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t("ClaroPay.learnMore")}
                </a>
              </p>
            </div>

            <div className="w-full px-6 lg:px-10">
              <div className="flex flex-col justify-center items-center gap-6 w-full md:min-h-52 bg-gradient-to-b from-[#c1ceff] via-[#d1f0ff] to-[#c1ceff] rounded-3xl p-8 pb-6 max-w-3xl">
                <div className="flex flex-col sm:flex-row md:flex-col xl:flex-row items-start gap-4">
                  <p className="text-2xl xl:text-3xl font-bold w-full text-center sm:text-left md:text-center xl:text-left sm:max-w-[16rem] md:max-w-none xl:max-w-[20rem] text-[#1A1A1A] sm:mt-5 md:mt-0 xl:mt-5">
                    {t("ClaroPay.coupon.title")}
                  </p>

                  <div className="w-full flex flex-col items-center justify-center gap-3">
                    <p className="w-full text-lg xl:text-xl font-semibold text-center text-[#1A1A1A] -mb-2">
                      {t("ClaroPay.coupon.subtitle")}
                    </p>
                    <p className="text-xl md:text-2xl lg:text-3xl text-white font-semibold uppercase bg-gradient-to-b from-[#b30105] to-[#f70208] px-2 py-1 rounded-lg">
                      {t("ClaroPay.coupon.couponName")}
                    </p>
                    <p
                      className="text-lg lg:text-xl text-center leading-tight [&_span]:font-semibold [&_span]:text-[#454efe] text-[#1A1A1A] max-w-lg"
                      dangerouslySetInnerHTML={{
                        __html: t("ClaroPay.coupon.description"),
                      }}
                    />
                  </div>
                </div>
                <p className="w-full text-center font-medium text-xs text-[#8795c3]">
                  {t("ClaroPay.coupon.disclaimer")}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full flex justify-center bg-[#063b83] rounded-b-large lg:rounded-b-[72px] lg:overflow-hidden max-lg:pb-20">
          <div className="w-full flex items-center justify-center max-w-screen-xl px-6 md:px-10 py-10 max-lg:pb-5">
            <div className="w-full lg:w-2/3 flex flex-col gap-4 h-full self-stretch justify-center max-lg:items-center flex-shrink-0 z-10 !min-w-52">
              <div>
                <p className="inline-block text-2xl sm:text-3xl lg:text-4xl text-center lg:text-left text-white font-semibold">
                  {t("ClaroPay.welcomeTo")}
                  <img
                    className="inline w-auto h-12 xs:h-16 lg:h-20 -translate-y-2 lg:-translate-y-3 -my-1 xs:-my-2 -mr-2"
                    src={SendolaPayLogoWhite}
                    alt="Sendola Logo"
                  />
                </p>
                <p className="text-base md:text-lg lg:text-xl text-center lg:text-left text-white font-light">
                  {t("ClaroPay.discover")}
                </p>
              </div>

              <div className="flex lg:hidden items-center justify-center w-fit rounded-3xl border-[#8495c1] border-[2px] overflow-hidden">
                {lang === "en" ? (
                  <img
                    className="object-contain h-auto w-full xs:w-[80%] max-w-sm z-10 flex-shrink-0 -mt-6 -mb-16"
                    src={PaymentMockEn}
                    alt="Payment mock"
                  />
                ) : (
                  <img
                    className="object-contain h-auto w-full xs:w-[80%] max-w-sm z-10 flex-shrink-0 -mt-6 -mb-16"
                    src={PaymentMockEs}
                    alt="Payment mock"
                  />
                )}
              </div>

              <p
                className="text-sm md:text-lg lg:text-xl text-center lg:text-left text-white font-semibold lg:mt-16 max-w-xl"
                dangerouslySetInnerHTML={{
                  __html: t("ClaroPay.receiveInMainBanks"),
                }}
              />
              <p
                className="text-sm md:text-lg lg:text-xl text-center lg:text-left text-white font-light [&_span]:font-semibold max-w-xl"
                dangerouslySetInnerHTML={{ __html: t("ClaroPay.banksAndMore") }}
              />
              <Button
                link={SignupUrlWithSource}
                className="!bg-primary-500 !px-10 !py-4 !border-none max-lg:mt-6 max-lg:-mb-32"
              >
                {t("ClaroPay.signUp")}
              </Button>
            </div>

            <div className="hidden w-1/3 lg:flex flex-col self-stretch relative flex-shrink-0">
              <div className="absolute bottom-[-80%] right-[-60%] w-[40rem] h-[40rem] xl:w-[48rem] xl:h-[48rem] bg-[#082c54] rounded-full z-0" />

              {lang === "en" ? (
                <img
                  className="object-contain h-auto w-full z-10 flex-shrink-0 -mt-8"
                  src={PaymentMockEn}
                  alt="Payment mock"
                />
              ) : (
                <img
                  className="object-contain h-auto w-full z-10 flex-shrink-0 -mt-8"
                  src={PaymentMockEs}
                  alt="Payment mock"
                />
              )}
              <p className="text-xs text-center font-medium text-[#8495c1] z-10">
                {t("ClaroPay.mockDisclaimer")}
              </p>
            </div>
          </div>
        </div>

        <div className="w-full flex justify-center items-center mt-14 pb-6 px-6 lg:px-10">
          <div className="flex flex-col md:flex-row gap-8 items-center justify-center w-full max-w-screen-lg rounded-3xl shadow-lg border-t-stone-200 border-t-[1px] shadow-black/10 p-6 sm:p-10">
            <p
              className="[&_span]:font-semibold text-lg md:texl-xl"
              dangerouslySetInnerHTML={{
                __html: t("ClaroPay.paymentMethodOptions"),
              }}
            />
            <div className="flex w-fit min-w-fit gap-3 items-center justify-between">
              <div className="p-1 w-16 h-16 xs:w-20 xs:h-20 lg:w-24 lg:h-24 bg-[#6d1ed4] rounded-full">
                <ZelleLogo className="w-full h-full text-white" />
              </div>
              <div className="p-1 w-16 h-16 xs:w-20 xs:h-20 lg:w-24 lg:h-24 bg-[#008cff] rounded-full">
                <VenomLogo className="w-full h-full text-white" />
              </div>
              <div className="p-1 w-16 h-16 xs:w-20 xs:h-20 lg:w-24 lg:h-24 bg-[#179bd7] rounded-full">
                <PayPalLogo className="w-full h-full text-white" />
              </div>
              <div className="p-1 w-16 h-16 xs:w-20 xs:h-20 lg:w-24 lg:h-24 bg-[#b18e5a] rounded-full">
                <AchLogo className="w-full h-full text-white" />
              </div>
            </div>
          </div>
        </div>

        <div className="w-full flex items-center justify-center px-10 py-10 bg-white">
          <div className="w-full flex flex-col items-center max-w-screen-xl gap-6">
            <p className="text-2xl xs:text-3xl text-center font-medium px-6">
              {t("ClaroPay.threeSteps")}
            </p>

            <div className="w-full flex flex-col md:flex-row justify-around gap-10 mt-6">
              <ClaroNumberedCard
                className="!px-8 !pt-6 md:!pt-4 !h-52 shadow-xl"
                number={1}
                text={t("ClaroPay.cards.card1")}
              >
                <Button
                  link={SignupUrlWithSource}
                  target="_blank"
                  rel={["noopener", "noreferrer"]}
                  className="!bg-primary-500 !border-0 !text-sm !px-8 !py-3 mt-2 !gap-2"
                >
                  {t("ClaroPay.sendolaOpenAccount")}
                </Button>
              </ClaroNumberedCard>
              <ClaroNumberedCard
                className="!px-8 !pt-6 md:!pt-4 !h-52 shadow-xl"
                number={2}
                text={t("ClaroPay.cards.card2")}
              >
                <UserIcon className="w-12 h-12 text-primary-500 flex-shrink-0 mt-2" />
              </ClaroNumberedCard>
              <ClaroNumberedCard
                className="!px-8 !pt-6 md:!pt-4 !h-52 shadow-xl"
                number={3}
                text={t("ClaroPay.cards.card3")}
                textClassName="inner-span-italic"
              >
                <SendIcon className="w-12 h-12 text-primary-500 flex-shrink-0 mt-2" />
              </ClaroNumberedCard>
            </div>
          </div>
        </div>

        <div className="w-full flex justify-center bg-gradient-to-br from-[#EFF3FD] to-[#DCE5FC] pt-20 md:pt-10 pb-10 px-6 md:px-10 overflow-hidden">
          <div className="w-full flex justify-center max-w-screen-xl">
            <div className="flex flex-col gap-6 w-full lg:flex-row max-w-screen-sm lg:max-w-none">
              <div className="flex flex-col items-start justify-between lg:mt-6 w-full lg:w-1/2 self-stretch">
                <div className="flex flex-col items-center md:items-start w-full lg:w-fit lg:min-w-[20rem]">
                  <h2
                    className="font-semibold text-2xl md:text-4xl text-[#1B326D] w-full text-center md:text-center"
                    dangerouslySetInnerHTML={{
                      __html: t("ClaroPay.form.title"),
                    }}
                  />
                  <p
                    className="md:text-lg mt-1 w-full text-center md:text-center"
                    dangerouslySetInnerHTML={{
                      __html: t("ClaroPay.form.subtitle"),
                    }}
                  />
                </div>

                <img
                  src={WomanSmiling}
                  className="hidden lg:block w-[80%] h-auto object-contain translate-y-12 object-bottom max-w-sm"
                />
              </div>

              <div className="flex justify-center w-full lg:w-1/2 !h-min">
                <Card className="!shadow-none !rounded-3xl !w-full !max-w-screen-md !p-0 border-[1px] border-primary-100">
                  <HubspotContactForm
                    portalId="44207752"
                    formId="0f4f26ee-6103-4e2b-a25d-e202e8747f70"
                    region="na1"
                  />
                </Card>
              </div>

              <div className="flex md:hidden w-full justify-center">
                <img
                  src={ManSmiling}
                  className="w-[80%] h-auto object-contain object-bottom max-w-sm -mb-12"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="w-full flex justify-center px-6 lg:px-10 bg-[#d72d25] py-10 lg:py-12 gap-10">
          <div className="w-full flex flex-col items-center lg:flex-row justify-around gap-8 max-w-screen-xl">
            <div className="relative h-full w-full lg:w-1/2 flex flex-col gap-2 lg:gap-4 text-white flex-1 flex-shrink-0 pt-2">
              <p className="text-3xl lg:text-4xl font-medium w-full lg:max-w-md text-center md:text-left">
                {t("ClaroPay.featuresCard.title")}
              </p>
              <p className="text-lg lg:text-xl font-light w-full text-center md:text-left">
                {t("ClaroPay.featuresCard.subtitle")}
              </p>
              <img
                className="hidden lg:block w-auto h-full max-w-[25rem] object-contain object-bottom absolute bottom-0 left-0 translate-y-12"
                src={ManSmiling}
                alt="Man smiling"
              />
            </div>
            <div className="w-full lg:w-1/2 flex flex-col gap-4 flex-shrink-0">
              <div className="w-full bg-white rounded-3xl flex flex-col gap-4 h-auto py-10 px-6 lg:px-10 flex-1">
                <div className="flex items-center p-[0.75] gap-5">
                  <div className="w-auto">
                    <div className="w-[42px] h-[42px] flex items-center justify-center rounded-full bg-[#d92f27]">
                      <SendIcon width={25} height={25} className="text-white" />
                    </div>
                  </div>
                  <p
                    className="text-left text-sm md:text-base lg:text-lg inner-span-bolden"
                    dangerouslySetInnerHTML={{
                      __html: t("ClaroPay.featuresCard.feature1"),
                    }}
                  />
                </div>
                <div className="flex items-center p-[0.75] gap-5">
                  <div className="w-auto">
                    <div className="w-[42px] h-[42px] flex items-center justify-center rounded-full bg-[#d92f27]">
                      <PhoneRingingIcon
                        width={25}
                        height={25}
                        className="text-white"
                      />
                    </div>
                  </div>
                  <p
                    className="text-left text-sm md:text-base lg:text-lg inner-span-bolden"
                    dangerouslySetInnerHTML={{
                      __html: t("ClaroPay.featuresCard.feature2"),
                    }}
                  />
                </div>
                <div className="flex items-center p-[0.75] gap-5">
                  <div className="w-auto">
                    <div className="w-[42px] h-[42px] flex items-center justify-center rounded-full bg-[#d92f27]">
                      <ReceiptCheckIcon
                        width={25}
                        height={25}
                        className="text-white"
                      />
                    </div>
                  </div>
                  <p
                    className="text-left text-sm md:text-base lg:text-lg inner-span-bolden"
                    dangerouslySetInnerHTML={{
                      __html: t("ClaroPay.featuresCard.feature3"),
                    }}
                  />
                </div>
                <div className="flex items-center p-[0.75] gap-5">
                  <div className="w-auto">
                    <div className="w-[42px] h-[42px] flex items-center justify-center rounded-full bg-[#d92f27]">
                      <CoinSendIcon
                        width={32}
                        height={32}
                        className="text-white"
                      />
                    </div>
                  </div>
                  <p
                    className="text-left text-sm md:text-base lg:text-lg inner-span-bolden"
                    dangerouslySetInnerHTML={{
                      __html: t("ClaroPay.featuresCard.feature4"),
                    }}
                  />
                </div>
                <div className="flex items-center p-[0.75] gap-5">
                  <div className="w-auto">
                    <div className="w-[42px] h-[42px] flex items-center justify-center rounded-full bg-[#d92f27]">
                      <WithdrawalIcon
                        width={25}
                        height={25}
                        className="text-white"
                      />
                    </div>
                  </div>
                  <p
                    className="text-left text-sm md:text-base lg:text-lg inner-span-bolden"
                    dangerouslySetInnerHTML={{
                      __html: t("ClaroPay.featuresCard.feature5"),
                    }}
                  />
                </div>
                <div className="flex items-center p-[0.75] gap-5">
                  <div className="w-auto">
                    <div className="w-[42px] h-[42px] flex items-center justify-center rounded-full bg-[#d92f27]">
                      <ShoppingCartIcon
                        width={25}
                        height={25}
                        className="text-white"
                      />
                    </div>
                  </div>
                  <p
                    className="text-left text-sm md:text-base lg:text-lg inner-span-bolden"
                    dangerouslySetInnerHTML={{
                      __html: t("ClaroPay.featuresCard.feature6"),
                    }}
                  />
                </div>
              </div>

              <div className="w-full flex justify-center items-center mt-6">
                <Button
                  link={CLAROPAY_OPEN_ACCOUNT}
                  className="lg:!text-lg !bg-white !text-black !border-none !px-12 !py-3"
                >
                  {t("ClaroPay.requestNow")}
                </Button>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full flex flex-col items-center justify-center gap-10 md:gap-8 p-10 bg-white">
          <div className="flex items-center gap-x-4 gap-y-3 flex-wrap justify-center">
            <p className="md:text-xl font-medium text-center md:text-left">
              {t("ClaroPay.inviteFriends")}
            </p>
            <div className="flex gap-4">
              <ClaroPayLargeLogo className="pb-2 h-10 w-auto" />
            </div>
          </div>

          <Button
            onClick={shareInvite}
            target="_blank"
            rel={["noopener", "noreferrer"]}
            className="!font-normal !bg-[#c51f1a] !border-0 w-fit !py-3 !px-8"
          >
            {t("ClaroPay.invite")}
          </Button>
        </div>
      </div>
    </>
  );
}
